import Onboarding from "@/pages/onboarding"
import { OnboardingStepperContext } from "@/pages/onboarding/onboardingStepper"
import { createFileRoute } from "@tanstack/react-router"

export const Route = createFileRoute("/onboarding/")({
  component: RouteComponent,
  beforeLoad: async () => {},
})

function RouteComponent() {
  return (
    <OnboardingStepperContext>
      <Onboarding />
    </OnboardingStepperContext>
  )
}
